"use client";
import Bars3Icon from "@heroicons/react/24/solid/Bars3Icon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import localImageLoader from "@/lib/local-image-loader";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useSearchContext } from "@/lib/hooks/searchContext/searchStore";
import SideBarMenu from "@/components/views/modals/sidebar/SidebarMenu";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/hooks/translationContext";

export default function NavbarSidebarAction() {
  const { t } = useTranslation();
  const [showSidebar, setShowSidebar] = useState(false);
  const { isOpen, setIsOpen } = useSearchContext();
  const isHomepage = usePathname() === "/";

  useEffect(() => {
    const headerRef = document.getElementById("site-navigation");

    if (showSidebar) {
      headerRef?.style.setProperty("z-index", "9999");
    } else if (!isOpen) {
      headerRef?.style.setProperty("z-index", "30");
    }
  }, [showSidebar, isOpen]);

  return (
    <div>
      <div className="absolute container flex justify-end !z-[99]">
        <SideBarMenu onClose={() => setShowSidebar(false)} show={showSidebar} />
      </div>

      <div className="md:flex hidden">
        <div
          className="h-12 duration-150 cursor-pointer group items-center gap-3 inline-flex"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          <Bars3Icon
            className={cn(
              "size-7 group-hover:text-secondary",
              isHomepage ? "text-white" : "text-primary",
            )}
          />

          <div className="size-[42px] shrink-0 rounded-full border-2 border-accent p-0.5">
            <Image
              loader={localImageLoader}
              sizes="42px"
              width={42}
              height={42}
              src="/placeholders/avatar.webp"
              onError={(e) => {
                e.currentTarget.src = "/placeholders/guest-avatar.webp";
              }}
              alt={t("sidebar-user-avatar-alt")}
              className="!w-full !h-full rounded-full object-cover group-hover:shadow"
            />
          </div>
        </div>
      </div>

      <div className="flex md:hidden">
        {isOpen ? (
          <XMarkIcon
            onClick={() => setIsOpen(!isOpen)}
            className="size-9 text-primary cursor-pointer"
          />
        ) : (
          <Bars3Icon
            onClick={() => setShowSidebar(!showSidebar)}
            className="size-9 text-primary cursor-pointer"
          />
        )}
      </div>
    </div>
  );
}
